/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_LedeInputs */

const en_how_page_lede = /** @type {(inputs: How_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps, and none of them needs a phone call to a coach. This is the way from finding someone nearby to a workout where the progress shows.`)
};

const pl_how_page_lede = /** @type {(inputs: How_Page_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pięć kroków i żaden nie wymaga telefonu do trenera. Tak wygląda droga od znalezienia kogoś w okolicy do treningu, na którym widać postęp.`)
};

/**
* | output |
* | --- |
* | "Five steps, and none of them needs a phone call to a coach. This is the way from finding someone nearby to a workout where the progress shows." |
*
* @param {How_Page_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_lede = /** @type {((inputs?: How_Page_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_lede(inputs)
	return en_how_page_lede(inputs)
});